var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoggedIn
        ? _c(
            "div",
            { attrs: { "data-test-id": "auth-links" } },
            [
              _c(
                "router-link",
                {
                  staticClass: "md-button simple-link simple-link-white",
                  attrs: {
                    tag: "button",
                    "md-ripple": false,
                    to: { name: "signup" },
                    "data-test-id": "auth-links-signup"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_signup()) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "md-button simple-link simple-link-white",
                  attrs: {
                    tag: "button",
                    "md-ripple": false,
                    to: { name: "login" },
                    "data-test-id": "auth-links-login"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_signin()) + "\n    ")]
              ),
              _vm._v(
                "\n    " + _vm._s(_vm.notificationMenuRefreshed()) + "\n  "
              )
            ],
            1
          )
        : _c(
            "md-menu",
            {
              staticClass: "nav__user",
              attrs: {
                "md-active": _vm.isUserCardOpen,
                "md-align-trigger": "",
                "md-size": "huge",
                "md-direction": "bottom-start",
                "data-test-id": "user-info"
              },
              on: {
                click: function($event) {
                  return _vm.setClipboard()
                },
                "update:mdActive": function($event) {
                  _vm.isUserCardOpen = $event
                },
                "update:md-active": function($event) {
                  _vm.isUserCardOpen = $event
                }
              }
            },
            [
              _c(
                "md-button",
                {
                  staticClass: "nav__user-triger-btn",
                  attrs: {
                    "md-menu-trigger": "",
                    "md-ripple": false,
                    "data-test-id": "user-info-toggle-btn"
                  }
                },
                [
                  _c(
                    "md-tooltip",
                    {
                      staticClass: "custom-user-tooltip",
                      attrs: {
                        "md-direction": "bottom",
                        "md-active": _vm.tooltipActive,
                        "data-test-id": "user-email-tooltip"
                      },
                      on: {
                        "update:mdActive": function($event) {
                          _vm.tooltipActive = $event
                        },
                        "update:md-active": function($event) {
                          _vm.tooltipActive = $event
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.userEmail) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c("md-icon", {
                    attrs: {
                      "md-src": "/static/img/user-2.svg",
                      "data-test-id": "user-info-toggle-btn-icon"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-menu-content",
                {
                  staticClass: "nav__user-dropdown nav-dropdown redesign-menu",
                  attrs: { "data-test-id": "user-info-list-container" }
                },
                [
                  _c(
                    "md-menu-item",
                    { attrs: { "data-test-id": "user-info-list-item" } },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-icon-button",
                          attrs: {
                            id: "clipboard-btn",
                            "data-clipboard-target": "#clipboard",
                            "data-test-id": "user-info-clipboard-btn"
                          },
                          on: { click: _vm.showCopySuccess }
                        },
                        [
                          _c(
                            "md-icon",
                            {
                              staticClass:
                                "detail-row__clipboard-icon md-icon-size-065x",
                              attrs: {
                                "data-test-id": "user-info-clipboard-btn-icon"
                              }
                            },
                            [_vm._v("\n            content_copy\n          ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "nav-dropdown__info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "nav-dropdown__email",
                            attrs: { "data-test-id": "user-info-email" }
                          },
                          [
                            _c("span", { attrs: { id: "clipboard" } }, [
                              _vm._v(_vm._s(_vm.userEmail))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.accountBlocked
                          ? _c(
                              "p",
                              {
                                staticClass: "nav-dropdown__status",
                                attrs: { "data-test-id": "user-info-status" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.accountStatus) +
                                    "\n          "
                                )
                              ]
                            )
                          : _c(
                              "p",
                              {
                                staticClass: "nav-dropdown__status",
                                attrs: { "data-test-id": "user-info-status" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.i18n.lbl_userBlocked()) +
                                    "\n          "
                                )
                              ]
                            )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-menu-item",
                    {
                      staticClass: "nav-dropdown__actions",
                      attrs: { "data-test-id": "user-info-list-item" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-wrap space-between" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "btn btn_narrow md-primary md-mint",
                              attrs: {
                                "data-test-id": "user-info-settings-btn"
                              },
                              on: { click: _vm.goSettings }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.lbl_settings()) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "btn btn_narrow md-primary",
                              attrs: {
                                id: "btnSignout",
                                "data-test-id": "user-info-logout-btn"
                              },
                              on: { click: _vm.signOut }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.lbl_signout()) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c81478fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c81478fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/UserInfo.vue
// module id = DOw3
// module chunks = 1